import { render, staticRenderFns } from "./SocialIcon.vue?vue&type=template&id=9c974a86&"
import script from "./SocialIcon.vue?vue&type=script&lang=js&"
export * from "./SocialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports